@if (!isDrawerOpen()) {
<div
  cdkDrag
  cdkDragBoundary="body"
  cdkDragLockAxis="y"
  class="floating-badge"
  [cdkDragFreeDragPosition]="savedPosition()"
  (cdkDragStarted)="onDragStarted()"
  (cdkDragEnded)="onDragEnded($event)"
  (click)="openDrawer(); $event.stopPropagation()"
>
  <div class="badge-content" cdkDragHandle>
    <div class="badge-icon" >
      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 1.33337H3.99996C3.26663 1.33337 2.66663 1.93337 2.66663 2.66671V13.3334C2.66663 14.0667 3.26663 14.6667 3.99996 14.6667H12C12.7333 14.6667 13.3333 14.0667 13.3333 13.3334V2.66671C13.3333 1.93337 12.7333 1.33337 12 1.33337ZM5.99996 2.66671H7.33329V6.00004L6.66663 5.50004L5.99996 6.00004V2.66671ZM12 13.3334H3.99996V2.66671H4.66663V8.66671L6.66663 7.16671L8.66663 8.66671V2.66671H12V13.3334Z" fill="white"/>
      </svg>
    </div>
    <div class="badge-text" >TIPIFICAR</div>
    <div
      class="badge-indicator"
      [style.background-color]="badgeState() === 'success' ? '#7DE840' : '#F14B26'"
    ></div>
  </div>
</div>
}
